<div class="box">

    <h3 mat-dialog-title>Success</h3>
    <div mat-dialog-content class="content">
        <span>{{data.subTitle}}</span>
        <div class="imgWrapper">
            <img src="assets/images/dailog-box/success.jpg " alt="">
        </div>

        <span class="description" [innerHTML]="data.description"></span>
    </div>
    <div mat-dialog-actions>
        <button mat-button class="Save" (click)="successAction()" (mouseover)="this.set = true"
            (mouseout)="this.set = false">{{data.label1 == null ? 'Continue' : data.label1}}</button>
    </div>
</div>
<div class="bg" [class.set]="set"></div>